import script from "./Announcement.vue?vue&type=script&setup=true&lang=js"
export * from "./Announcement.vue?vue&type=script&setup=true&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=14c74e9e&lang=css"

const __exports__ = script;

export default __exports__